import { BaseApi } from './apiBase'
import type { 
  TeamContentPageIndex, 
  TeamContentPageShow,
  TeamContentPagesResponse,
  TeamContentPageResponse 
} from '../types/teamContentPage.types'

export class TeamContentPagesApi extends BaseApi {
  constructor() {
    super('/api/public')
  }

  async getContentPages(teamId: string): Promise<TeamContentPageIndex[]> {
    return this.get<TeamContentPageIndex[]>(`/teams/${teamId}/content_pages`)
  }

  async getContentPagesBySubdomain(subdomain: string): Promise<TeamContentPageIndex[]> {
    return this.get<TeamContentPageIndex[]>(`/teams/0/content_pages`, {
      bySubdomain: subdomain
    })
  }

  async getContentPage(teamId: string, slug: string): Promise<TeamContentPageShow> {
    return this.get<TeamContentPageShow>(`/teams/${teamId}/content_pages/${slug}`)
  }

  async getContentPageBySubdomain(subdomain: string, slug: string): Promise<TeamContentPageShow> {
    return this.get<TeamContentPageShow>(`/teams/0/content_pages/${slug}`, {
      bySubdomain: subdomain
    })
  }
}

export const teamContentPagesApi = new TeamContentPagesApi()